/**
 * App shell: maps route componentKey → React Component.
 * Lives in the presentation/app layer so it can depend on features (clean architecture).
 * Core layer (core/features/registry) holds only data (path, componentKey, permission, moduleId).
 */

import type {ComponentType} from 'react';
import Dashboard from '../features/dashboard/pages/Dashboard';
import ProviderDashboard from '../features/dashboard/pages/ProviderDashboard';
import {MapPage, StoresMapPage} from '../features/map';
import {MarketersManagementPage} from '../features/marketers';
import ProductsPage from '../features/products/pages/ProductsPage';
import AddStockPage from '../features/products/pages/AddStockPage';
import InventoryPage from '../features/inventory/pages/InventoryPage';
import {StoresManagementPage} from '../features/stores';
import StoreDeliveriesPage from '../features/stores/pages/StoreDeliveriesPage';
import ServiceProvidersPage from '../features/serviceProviders/pages/ServiceProvidersPage';
import VisitsPage from '../features/visits/pages/VisitsPage';
import MarketerTrackingPage from '../features/marketerTracking/pages/MarketerTrackingPage';
import PaymentCollectionPage from '../features/payments/pages/PaymentCollectionPage';
import {DistributionPage} from '../features/distribution';
import {SalesManagementPage} from '../features/sales';
import {UsersManagementPage} from '../features/users/pages/UsersManagementPage';
import ReportsIndexPage from '../features/reports/pages/ReportsIndexPage';
import MarketerReportsPage from '../features/reports/pages/MarketerReportsPage';
import ProductSalesReportPage from '../features/reports/pages/ProductSalesReportPage';
import {ChecklistsManagementPage} from '../features/checklists';

const ROUTE_COMPONENT_MAP: Record<string, ComponentType> = {
  Dashboard,
  ReportsIndexPage,
  MarketerReportsPage,
  ProductSalesReportPage,
  ProviderDashboard,
  MapPage,
  StoresMapPage,
  MarketersManagementPage,
  ServiceProvidersPage,
  ProductsPage,
  InventoryPage,
  AddStockPage,
  StoresManagementPage,
  StoreDeliveriesPage,
  VisitsPage,
  MarketerTrackingPage,
  DistributionPage,
  PaymentCollectionPage,
  SalesManagementPage,
  UsersManagementPage,
  ChecklistsManagementPage
};

export function getRouteComponent (componentKey: string): ComponentType | undefined {
  return ROUTE_COMPONENT_MAP[componentKey];
}
